import React from 'react';
import { CButton } from '@coreui/react';
import PropTypes from 'prop-types';

const FloatingSelectionBar = ({
  selectedCount,
  onClearSelection,
  onArchiveSelected,
  onArchiveAll,
  archiveSelectedText = 'Archive Selected',
  archiveAllText = 'Archive All',
}) => {
  if (selectedCount <= 0) return null;

  return (
    <div className="fixed flex items-center justify-between px-5 py-3 shadow-xl left-1/2 -translate-x-1/2 bottom-[30px] bg-white text-gray-800 rounded-xl z-[1050] w-auto min-w-[480px] border border-gray-200 border-l-4 border-l-[#3B74BE]">
      <div className="flex items-center">
        <span className="font-bold text-sm text-[#3B74BE]">
          {selectedCount} Selected
        </span>
        <div className="h-5 w-[1px] bg-gray-200 mx-4" />
      </div>
      <div className="flex items-center gap-3">
        <CButton
          className="text-xs p-0 mr-2 text-gray-500 hover:text-gray-800"
          onClick={onClearSelection}
          variant="ghost"
        >
          Clear Selection
        </CButton>
        {onArchiveSelected && (
          <CButton
            color="aimhi-textlight-neutral"
            size="sm"
            className="px-3 rounded-md font-semibold text-xs"
            onClick={onArchiveSelected}
          >
            {archiveSelectedText}
          </CButton>
        )}
        {onArchiveAll && (
          <CButton
            color="aimhi-textlight-neutral"
            variant="outline"
            size="sm"
            className="px-3 rounded-md font-semibold text-xs"
            onClick={onArchiveAll}
          >
            {archiveAllText}
          </CButton>
        )}
      </div>
    </div>
  );
};

FloatingSelectionBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onClearSelection: PropTypes.func.isRequired,
  onArchiveSelected: PropTypes.func,
  onArchiveAll: PropTypes.func,
  archiveSelectedText: PropTypes.string,
  archiveAllText: PropTypes.string,
};

export default FloatingSelectionBar;
